"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styler_1 = require("../styler");

var prefixer_1 = require("./prefixer");

var render_1 = require("./render");

var transform_props_1 = require("./transform-props");

var value_types_1 = require("./value-types");

var cssStyler = styler_1.default({
  onRead: function onRead(key, _a) {
    var element = _a.element,
        preparseOutput = _a.preparseOutput;
    var valueType = value_types_1.default(key);

    if (transform_props_1.isTransformProp(key)) {
      return valueType ? valueType.default || 0 : 0;
    } else {
      var domValue = window.getComputedStyle(element, null).getPropertyValue(prefixer_1.default(key, true)) || 0;
      return preparseOutput && valueType && valueType.parse ? valueType.parse(domValue) : domValue;
    }
  },
  onRender: function onRender(state, _a, changedValues) {
    var element = _a.element,
        enableHardwareAcceleration = _a.enableHardwareAcceleration;
    element.style.cssText += render_1.default(state, changedValues, enableHardwareAcceleration);
  },
  aliasMap: render_1.aliasMap
});

exports.default = function (element, props) {
  return cssStyler(__assign({
    element: element,
    enableHardwareAcceleration: true,
    preparseOutput: true
  }, props));
};